const PlatformAPIEventType = {};
export default PlatformAPIEventType;

PlatformAPIEventType.PROGRESS = "progress_event";
PlatformAPIEventType.INTERACTION = "interaction_event";
PlatformAPIEventType.SAVE_REQUEST = "interaction_state_save_request";
// PoC Async Events
PlatformAPIEventType.POC_ASYNC_EVENT = "poc_async_event";